import { type Locale } from '@aysar/contracts';

/**
 * `system` is a real third state, not a synonym for one of the other two: an
 * operator who has never chosen follows their OS, and follows it when it changes
 * at dusk. Collapsing it to a resolved value at write time would freeze whatever
 * the OS happened to be on their first visit.
 */
export const THEME_PREFERENCES = ['light', 'dark', 'system'] as const;
export type ThemePreference = (typeof THEME_PREFERENCES)[number];

/** What actually gets painted, after `system` is resolved against the OS. */
export type ResolvedTheme = 'light' | 'dark';

export interface PreferencesState {
  theme: ThemePreference;
  locale: Locale;
  sidebarCollapsed: boolean;
  /**
   * The sidebar groups the operator has open, by the group's `labelKey`. A
   * group is closed unless named here; the one holding the current route is
   * opened for them on navigation.
   */
  openNavGroups: readonly string[];
}

/** The minimal root shape the preference selectors need (see `AuthRoot`). */
export interface PreferencesRoot {
  preferences: PreferencesState;
}
